import { useEffect, useState } from "react";
import { Eye, EyeOff, Loader2, Star } from "lucide-react";
import { http } from "@/lib/adminApi";

export const Stars = ({ n, className = "h-4 w-4" }) => (
  <span className="flex gap-0.5" aria-label={`${n} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`${className} ${i <= n ? "fill-[var(--amber)] text-[var(--amber)]" : "text-white/20"}`} />)}
  </span>
);

export const ReviewsPanel = () => {
  const [reviews, setReviews] = useState(null);
  useEffect(() => {
    http.get("/admin/reviews").then((r) => setReviews(Array.isArray(r.data?.reviews) ? r.data.reviews : [])).catch(() => setReviews([]));
  }, []);

  const toggle = async (r) => {
    const visible = !r.visible;
    setReviews((list) => list.map((x) => (x.id === r.id ? { ...x, visible } : x)));
    try { await http.patch(`/admin/reviews/${r.id}`, { visible }); }
    catch { setReviews((list) => list.map((x) => (x.id === r.id ? { ...x, visible: r.visible } : x))); }
  };

  if (!reviews) return <Loader2 className="mx-auto mt-16 h-6 w-6 animate-spin text-[var(--teal)]" />;
  return (
    <div className="mt-10" data-testid="admin-reviews-panel">
      <p className="text-sm text-slate-300">5-star reviews show on your site automatically. Use Show/Hide to choose what visitors see; the top 6 shown appear on the landing page.</p>
      {reviews.length === 0 && <p className="mt-8 text-slate-300" data-testid="admin-reviews-empty">No reviews yet. Customers get a review link with their finished files.</p>}
      <ul className="mt-8 space-y-4">
        {reviews.map((r) => (
          <li key={r.id} className={`rounded-2xl border p-5 sm:p-6 ${r.visible ? "border-[var(--teal)]/40 bg-[var(--navy)]" : "border-white/10 bg-[var(--navy)]/50"}`} data-testid={`admin-review-${r.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-3">
              <Stars n={r.rating} />
              <button onClick={() => toggle(r)} data-testid={`admin-review-toggle-${r.id}`}
                className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold ${r.visible ? "bg-[var(--teal)] text-[var(--ink)]" : "border border-white/20 text-slate-200 hover:border-[var(--teal)]"}`}>
                {r.visible ? <><Eye className="h-4 w-4" /> Showing on site</> : <><EyeOff className="h-4 w-4" /> Hidden · show it</>}
              </button>
            </div>
            <p className="mt-3 whitespace-pre-wrap text-white">“{r.text}”</p>
            <p className="mt-2 text-sm text-slate-400">{r.display_name}{r.role ? `, ${r.role}` : ""} · {r.email} · {new Date(r.created_at).toLocaleDateString()}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};
